export default __webpack_public_path__ + "static/media/logo.00a5a620.png";